import { useCallback } from 'react';

import { FormContextValues } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../../translations';

export type AppointmentTimeSlotOccupiedErrorHandlerProps = {
   setAppointmentTimeSlotOccupiedError: VoidFunction;
};

export const useAppointmentTimeSlotOccupiedErrorHandler = (
   setError: FormContextValues<{ startTime: string; endTime: string }>['setError']
): VoidFunction => {
   return useCallback(() => {
      setError('startTime', { message: appointmentsTranslationKeys.timeSlotOccupied });
      setError('endTime', true);
   }, [setError]);
};
